import { Component } from '@angular/core';
import { OrderMetrics } from '@compumark/analyst-selection-tool-client';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-order-history-details',
  standalone: false,
  templateUrl: './order-history-details.component.html',
  styleUrls: ['./order-history-details.component.scss'],
})
export class OrderHistoryDetailsComponent {
  orderMetrics?: OrderMetrics;
  kibanaUrl?: string;
  constructor() {}
  agInit(params: ICellRendererParams): void {
    this.orderMetrics = params.data.orderMetrics;
    this.kibanaUrl = params.data.kibanaUrl;
  }
}
